import { Button } from '@eppendorf/vnls-react-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AddNotificationRuleDialog } from '$features/notifications/add-or-edit-notification-rule-dialog';

import { DashboardCardTitle } from './dashboard-card-title';
import { DashboardWidget } from './dashboard-widget';
import { SectionFeedback } from './section-feedback';

import './quick-actions-bar.scss';

interface QuickActionsBarProps {
  canCreateNotificationRule: boolean;
  canCreateReport: boolean;
}

export function QuickActionsBar({
  canCreateNotificationRule,
  canCreateReport,
}: QuickActionsBarProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isNotificationDialogOpen, setIsNotificationDialogOpen] = useState(false);

  if (!canCreateNotificationRule && !canCreateReport) {
    return null;
  }

  return (
    <DashboardWidget className="quick-actions-bar">
      <div className="dashboard-widget__header">
        <DashboardCardTitle
          icon="trigger"
          title={t('dashboard.quickActions.title')}
          hint={t('dashboard.quickActions.hint')}
        />
        <div className="quick-actions-bar__header-actions">
          <SectionFeedback sectionId="quick-actions" />
          <div className="quick-actions-bar__buttons">
            {canCreateReport && (
              <Button variant="secondary" onClick={() => navigate('/report-hub')}>
                {t('dashboard.quickActions.createReport')}
              </Button>
            )}
            {canCreateNotificationRule && (
              <Button variant="primary" onClick={() => setIsNotificationDialogOpen(true)}>
                {t('dashboard.quickActions.createNotificationRule')}
              </Button>
            )}
          </div>
        </div>
      </div>
      {canCreateNotificationRule && (
        <AddNotificationRuleDialog
          isOpen={isNotificationDialogOpen}
          onOpenChange={setIsNotificationDialogOpen}
        />
      )}
    </DashboardWidget>
  );
}
